import { render, staticRenderFns } from "./FormControlTypeDate.vue?vue&type=template&id=28962f73&scoped=true"
import script from "./FormControlTypeDate.vue?vue&type=script&lang=js"
export * from "./FormControlTypeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28962f73",
  null
  
)

export default component.exports